import React from 'react';
import { TextBlock, EllipsisText, Text } from 'bench-internal-theme';
import { Connection } from '../types';
import styled from 'styled-components';
import { colors } from 'bench-style-constants';

type SquareLocationTableProps = {
  connection: Connection;
};

const TableHeaderLayout = styled(TextBlock).attrs(() => ({
  color: colors.smoke,
  styleType: 'small',
  uppercase: true,
}))`
  align-items: center;
  background-color: ${colors.pearl};
  border-top: 1px solid ${colors.silt};
  box-shadow: 0 1px 0 ${colors.silt};
  min-height: 33px;
  display: grid;
  grid-column-gap: 16px;
  padding: 8px;
  grid-template-columns: 2fr 2fr 1fr 1fr;
  };
`;

const TableRow = styled.div`
  align-items: center;
  background-color: ${colors.white};
  border-bottom: 1px solid ${colors.silt};
  display: grid;
  grid-column-gap: 16px;
  padding: 8px;
  grid-template-columns: 2fr 2fr 1fr 1fr;
};
`;

const SquareLocationTable = ({ connection }: SquareLocationTableProps) => {
  return (
    <>
      <TableHeaderLayout>
        <div>Location</div>
        <div>ID</div>
        <div>Currency</div>
        <div>Active</div>
      </TableHeaderLayout>
      {connection.accounts.map(account => (
        <TableRow key={account.id}>
          <EllipsisText>
            <Text styleType="small" color={colors.cloud}>
              {account.name}
            </Text>
          </EllipsisText>
          <Text styleType="small" color={colors.cloud}>
            {account.sourceId}
          </Text>
          <Text styleType="small" color={colors.cloud}>
            {account.defaultCurrency}
          </Text>
          <Text styleType="small" color={colors.cloud}>
            {account.isActive ? 'Active' : 'Inactive'}
          </Text>
        </TableRow>
      ))}
    </>
  );
};

export default SquareLocationTable;
